import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20lifestyle%20flatlay%20with%20cream%20knit%20sweater%2C%20neutral%20beige%20textiles%2C%20golden%20brass%20accessories%2C%20soft%20morning%20sunlight%20streaming%20through%20linen%20curtains%2C%20clean%20aesthetic%20composition%20with%20warm%20terracotta%20and%20sage%20green%20accents%2C%20elegant%20product%20photography%20style%20with%20organic%20textures%20and%20gentle%20shadows%2C%20editorial%20quality%2C%20cozy%20yet%20refined%20atmosphere&width=1600&height=900&seq=hero-bg-v2-01&orientation=landscape"
        alt="Sugargoo Spreadsheet lifestyle hero background"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/90 text-primary-600 text-xs font-semibold tracking-wide uppercase mb-6">
          Updated 2026 Database
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          The Ultimate <span className="text-accent-400">Sugargoo Spreadsheet</span> Resource Hub
        </h1>

        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover the latest Sugargoo Spreadsheet collections, product guides, reviews, shipping information, 
          coupons and expert shopping tips — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line ml-2"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 text-base font-semibold hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-cart-line ml-2"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          <div className="flex items-center gap-2 text-white/70 text-xs">
            <i className="ri-checkbox-circle-line text-secondary-400"></i>
            <span>Updated Database</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-xs">
            <i className="ri-checkbox-circle-line text-secondary-400"></i>
            <span>Beginner Friendly</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-xs">
            <i className="ri-checkbox-circle-line text-secondary-400"></i>
            <span>Shopping Guides</span>
          </div>
          <div className="flex items-center gap-2 text-white/70 text-xs">
            <i className="ri-checkbox-circle-line text-secondary-400"></i>
            <span>Safety Information</span>
          </div>
        </div>
      </div>
    </section>
  );
}